import { render } from "./SogCardTitle.vue?vue&type=template&id=0e3d31ad"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__